var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPreview(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.01677 11.0937C1.90328 10.914 1.84654 10.8241 1.81477 10.6855C1.79091 10.5814 1.79091 10.4173 1.81477 10.3132C1.84654 10.1746 1.90328 10.0847 2.01677 9.90503C2.95461 8.42005 5.74617 4.66602 10.0003 4.66602C14.2545 4.66602 17.0461 8.42005 17.9839 9.90503C18.0974 10.0847 18.1541 10.1746 18.1859 10.3132C18.2098 10.4173 18.2098 10.5814 18.1859 10.6855C18.1541 10.8241 18.0974 10.914 17.9839 11.0937C17.0461 12.5786 14.2545 16.3327 10.0003 16.3327C5.74617 16.3327 2.95461 12.5786 2.01677 11.0937Z",
    stroke: "#2F80ED",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0003 12.9993C11.381 12.9993 12.5003 11.8801 12.5003 10.4993C12.5003 9.11864 11.381 7.99935 10.0003 7.99935C8.61962 7.99935 7.50034 9.11864 7.50034 10.4993C7.50034 11.8801 8.61962 12.9993 10.0003 12.9993Z",
    stroke: "#2F80ED",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreview);
export default __webpack_public_path__ + "static/media/preview.ca8d09032634a1833bcee8ba7ff85325.svg";
export { ForwardRef as ReactComponent };